/** サーバー返却の workedCount から初回勤務未完了か判定する（クライアント側で独自集計しない） */
export const isFirstWorkIncomplete = (
  workedCount: number | null | undefined,
): boolean => (workedCount ?? 0) === 0;
